import { IOffer } from '../../../types/offer';
import { isSuburban } from '../category/isSuburban';
import { isGarage } from '../category/isGarage';
import { getFloorRange } from './getFloorRange';

export function getFloor(offer: IOffer): string | undefined {
  const isSuburbanCategory = isSuburban(offer);
  const isGarageCategory = isGarage(offer);

  if (!isSuburbanCategory && !isGarageCategory) {
    return getFloorRange(offer);
  }

  return undefined;
}
